import React from "react";

import nullclass from "../assets/nullclass.jpg";
import topperworld from "../assets/topperworld.jpeg";
import top5 from "../assets/top5.png";

import '../styles/Certificates.css'

const Certificates = () => {
  return (
    <div className="certificates">
       <h2 className="section-heading">
          Certificates
        </h2>
        <div className="certificate-container">


        <div className="certificate-box">
        <img src={nullclass} alt="nullclass" className="cer" />
        <div className="linee">Completion of tranning at NullClass</div>
      </div>
      <div className="certificate-box">
        <img src={topperworld} alt="nullclass" className="cer" />
        <div className="linee">Completion of internship at Topperworld</div>
      </div>
      <div className="certificate-box">
       
        <img src={top5} alt="nullclass" className="cer" />
        <div className="linee">Secured a position among the top 5 interns out of a competitive group <a href="https://www.linkedin.com/feed/update/urn:li:activity:7174430851026362369/">Click Here</a> </div>
      </div>

        </div>

    </div>
  );
};

export default Certificates;
